import { BEE_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'
import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'

export class BeeService {
  static getListByPhone = async phone => {
    try {
      const res = await HTTPHandler.get(
        BEE_API_URL + '/call/getByPhone/' + phone
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static getCallFileByCallId = async id => {
    try {
      const res = await HTTPHandler.get(BEE_API_URL + '/call/getCallFile/' + id)
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}

export default BeeService
